import React, { MouseEventHandler, useState } from 'react';

import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';

import { LOCAL_STORAGE_KYC_POPUP_KEY } from 'constants/constants';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { useLocalStorage, useTotalAccountEquity } from 'hooks';
import Alert from 'styles/assets/icons/Alert';
// import DollarBill from 'styles/assets/icons/DollarBill';

import classes from './kyc.module.scss';

interface ModalChildProps {
  toggleModal: React.MouseEventHandler<
    HTMLButtonElement | HTMLDivElement | HTMLAnchorElement
  >;
  totalBalance: number;
}

const ModalChild = ({ toggleModal, totalBalance }: ModalChildProps) => {
  const { t } = useTranslation(['markets', 'common']);

  const kycDate = {
    date: '15',
    month: 'Sep',
    year: '22',
  };

  // let isEligibleForOffer = false;
  if (!totalBalance) {
    // isEligibleForOffer = false;
    kycDate.date = '29';
    kycDate.month = 'Aug';
  }

  return (<>
    <div className={classes.kyc_modal__top} data-palette="ModalChild">
      <h2 className={classes.kyc_modal__heading}>
        <Alert />
        {t('markets:kycModal.topHeading')}
      </h2>
    </div>
    <div className={classes.kyc_modal__main} data-palette="ModalChild">
      <div className={classes['kyc_modal__main-text']}>
        <h3>
          {!totalBalance
            ? t('markets:kycModal.contentHeading2', kycDate)
            : t('markets:kycModal.contentHeading', kycDate)}
        </h3>
      </div>
      {/* {isEligibleForOffer && (
        <div className={classes['kyc_modal__main-subtitle']}>
          <div className={classes.iconWrapper}>
            <DollarBill height={15} width={13.5} viewBox="0 0 13.5 15" />
          </div>
          <h3>
            {t('markets:kycModal.contentHeading1', {
              date: '5',
              month: 'Sep',
              year: '22',
              reward: '250',
            })}
          </h3>
        </div>
      )} */}
    </div>
    <div className={classes.kyc_modal__btnContainer} data-palette="ModalChild">
      <button
        type="button"
        data-testid="kyc_modal_cancel_btn"
        className={classes.kyc_modal__cancelBtn}
        onClick={toggleModal}
      >
        {t('common:remindMeLater')}
      </button>
      <Link
        className={classes.kyc_modal__verifyBtn}
        to={routes.account.identityVerification}
        onClick={toggleModal as MouseEventHandler<HTMLAnchorElement>}
        data-testid="kyc-modal-verify-link"
      >
        {t('common:startKYC')}
      </Link>
    </div>
  </>);
};

const KycModal = () => {
  const [showModal, setShowModal] = useState(true);
  const setClosedTime = useLocalStorage(LOCAL_STORAGE_KYC_POPUP_KEY, '')[1];
  const totalBalance = useTotalAccountEquity();

  const setPoupClosedTime = () => {
    const timeNow = String(new Date());
    return setClosedTime(timeNow);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
    trackMixpanelEvent(MIXPANEL_EVENT_NAMES.ACCOUNT.IDENTITY_VERIFICATION.ALL_PAGES, {
      source: 'KYC Modal',
    });
    return setPoupClosedTime();
  };

  if (totalBalance === 'loading') return null;

  return (
    <Modal
      className={classes.kyc_modal}
      isOpen={showModal}
      overlayClassName={classes.overlay}
    >
      <ModalChild totalBalance={Number(totalBalance)} toggleModal={toggleModal} />
    </Modal>
  );
};

export default KycModal;
